const PROD_URL = "/products";
export const state = {
  products: [],
  GroupedProducts: [],
  cart: [],
  loading: false,
};
export const mutations = {
  RESET_PRODUCTS(state) {
    state.products = [];
  },
  RESET_CART(state) {
    state.cart = [];
  },
  CLEAR_CART_IF(state, from) {
    // console.log(retail);
    let { retail } = from || { retail: false };
    if (!state.cart.length) return;

    let isRetailCart = state.cart.every(item => item.retail === true);
    if (retail !== isRetailCart) state.cart = [];
  },
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
  SET_GROUP_PRODUCTS(state, ProductObj) {
    state.GroupedProducts = Object.keys(ProductObj).map(key => {
      return ProductObj[key];
    });
  },
  SET_LOADING(state, isLoading) {
    state.loading = isLoading;
  },

  INCREASE_DECREASE_CART(state, { type, item, retail }) {
    // console.log(state.cart);
    if (type == "dec") {
      if (item.qty == 1) {
        state.cart = state.cart.filter(prod => prod.product !== item.product);
      } else
        state.cart = state.cart.map(prod => {
          return prod.product == item.product
            ? { ...prod, qty: item.qty - 1 }
            : prod;
        });
    } else {
      let { qty, UnitQty } = state.products.find(
        prod => prod.product == item.product
      );
      // console.log(retail);
      let itemQty = qty;
      if (retail) itemQty = qty * UnitQty;
      if (item.qty < itemQty)
        state.cart = state.cart.map(cart =>
          item.product == cart.product ? { ...item, qty: cart.qty + 1 } : cart
        );
    }
  },

  ADD_TO_CART(state, cart) {
    // console.log(cart);
    // const old = state.cart.find(
    //   item => item.product == cart.product && item.code == cart.code
    // );
    const old = state.cart.find(item => item.product == cart.product);
    if (old) {
      if (old.qty == cart.qty) return null;
      else {
        state.cart = state.cart.filter(prod => prod.product !== old.product);
        state.cart.unshift({ ...old, qty: old.qty + 1 });
      }
    } else {
      // cart.qty = 1;
      // console.log(cart);
      if (cart.qty >= 1) state.cart.unshift({ ...cart, qty: 1 });
    }
  },
  DIRECT_CART(state, cart) {
    // console.log(cart);
    // state.cart = state.cart.filter(
    //   prod => prod.product !== cart.product || prod.code !== cart.code
    // );
    state.cart = state.cart.filter(prod => prod.product !== cart.product);
    state.cart.unshift(cart);
  },
  CLEAR_TO_CART(state) {
    state.cart = [];
  },
  UDATE_PRODUCT(state, UpdateList) {
    // UpdateList.forEach(({ product, qty }) => {
    //   state.GroupedProducts = state.GroupedProducts.map(item => {
    //     return item.product == product
    //       ? { ...item, qty: item.qty + qty }
    //       : item;
    //   }).filter(item => item.qty > 0);
    // });
    UpdateList.forEach(({ product, qty, code }) => {
      state.products = state.products
        .map(item => {
          return item.product == product && item.code == code
            ? { ...item, qty: item.qty + qty }
            : item;
        })
        .filter(item => item.qty > 0);
    });
  },
};
export const actions = {
  LoadProdacts({ dispatch, commit }) {
    try {
      commit("SET_LOADING", true);
      dispatch("FIND_BY_VALUE", { url: PROD_URL })
        .then(result => {
          // console.log(result.data);

          commit("SET_LOADING", false);
          commit("SET_PRODUCTS", result.data);
        })
        .catch(err => {
          commit("SET_LOADING", false);
          console.log(err);
        });
    } catch (error) {
      commit("SET_LOADING", false);
      console.log(error);
    }
  },
  AddToCart({ commit }, product) {
    // console.log(product);
    // eslint-disable-next-line no-unused-vars
    let { invCateg, ...item } = product;
    // item.qty = 1;
    commit("ADD_TO_CART", item);
    // console.log(product);
  },
  SellProduct({ dispatch, getters, commit }, product) {
    return new Promise((resolve, reject) => {
      try {
        const Req = {
          url: `${PROD_URL}/store`,
          data: {
            product: getters.FormattedCart,
            ...product,
          },
        };
        // throw Error("unknow");
        // console.log(Req.data);

        // eslint-disable-next-line no-unused-vars
        dispatch("INSERT_ONLY", Req)
          .then(({ data }) => {
            // console.log(val);
            commit("UDATE_PRODUCT", data.soldProduct);
            resolve(data.orderCode);
          })
          .catch(error => {
            reject(error);
          });
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};

export const getters = {
  FormattedCart(state) {
    const newCart = [];
    state.cart.forEach(cart => {
      const { qty, UnitQty, retail } = cart;
      const { codes, ...cartFilter } = cart;
      let CartQTY = qty;
      // if(retail)
      const sortedCodes = [...codes].sort((a, b) => {
        // console.log(a, b);
        return a.qty < b.qty;
      });
      // console.log("sorted", sortedCodes);

      const result = sortedCodes.find(trn => {
        if (retail) return parseInt(trn.qty) * UnitQty == CartQTY;
        return parseInt(trn.qty) == CartQTY;
      });
      if (result) {
        console.log("result", result);
        newCart.push({
          ...cartFilter,
          cost: result.cost,
          code: result.code,
        });
        return;
      }

      let index = codes.length - 1;
      while (index != -1) {
        const lastItem = sortedCodes[index--];
        let _qty = lastItem.qty;
        if (retail) _qty *= UnitQty;

        if (parseInt(_qty) < CartQTY) {
          CartQTY -= parseInt(_qty);
          newCart.push({
            ...cartFilter,
            code: lastItem.code,
            qty: parseInt(_qty),
          });
        } else {
          newCart.push({
            ...cartFilter,
            code: lastItem.code,
            qty: CartQTY,
          });
          CartQTY -= CartQTY;
          break;
        }
      }
    });
    return newCart;
  },
  getProducts({ products }) {
    return products.map(item => {
      return {
        ...item,
        _id: item.code + item.product,
      };
    });
  },
  getGroupedProducts({ products }) {
    const newData = products.reduce((prods, item) => {
      let { qty, codes, price } = prods[item.product] || {
        qty: 0.0,
        codes: [],
        price: 0.0,
      };
      // const { code } = item;
      // if(price<item.price)

      prods[item.product] = {
        // ...prods,
        InvName: item.InvName,
        qty: parseFloat((qty + item.qty).toFixed(2)),
        AccountName: item.AccountName,
        invCateg: item.invCateg,
        UnitType: item.UnitType,
        UnitQty: item.UnitQty,
        price: item.price < price ? price : item.price,
        cost: item.cost,
        product: item.product,
        branch: item.branch,
        codes: [
          ...codes,
          {
            code: item.code,
            price: item.price,
            cost: item.cost,
            qty: item.qty,
          },
        ],
      };
      return prods;
    }, {});
    return Object.keys(newData).map(key => {
      return { ...newData[key], _id: key };
    });

    // return GroupedProducts.map(item => {
    //   return {
    //     ...item,
    //     _id: item.product,
    //   };
    // });
  },
  isLoading({ loading }) {
    return loading;
  },
  getCarts({ cart }) {
    return cart;
  },
};
